import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { SimpleModel } from '../../components/examples/';
export const _frontmatter = {
  "Title": "A simple model"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "a-simple-model"
    }}>{`A simple model`}</h1>
    <SimpleModel mdxType="SimpleModel" />
    <p>{`This model just shows how the various parts of react-sim work together.
100 cells are arranged on a grid from top-left to bottom-right. A cell is black if its number is less than the current tick.`}</p>
    <p>{`This model doesn't have a `}<inlineCode parentName="p">{`initData`}</inlineCode>{` or an `}<inlineCode parentName="p">{`updateData`}</inlineCode>{`, it just works with the value of the `}<inlineCode parentName="p">{`tick`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      